import { useEffect, useState } from 'react';
import { isNil } from 'lodash';
import useRequest from './UseRequest';
import useCancelableRequests from './UseCancelableRequests';
// Import Services
import { UtilsHttpService } from 'services/http';
// Import Enums
import { AwardTypesEnum } from 'enums';
// Import Types
import { SpinExchangeRate } from 'types';

const useOneSpinRates = ({ bonusType, configJson }: { bonusType?: AwardTypesEnum; configJson?: string | null }) => {
    const { doGetRequest } = useRequest();
    const { getSpinExchangeRatesRequest } = useCancelableRequests({
        getSpinExchangeRatesRequest: UtilsHttpService.getSpinExchangeRatesRequest,
    });

    const [rates, setRates] = useState<SpinExchangeRate[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!bonusType) return;

        let parsedConfig;

        if (!isNil(configJson)) {
            try {
                parsedConfig = JSON.parse(configJson);

                if (parsedConfig?.Rates?.length) {
                    setRates(parsedConfig.Rates);
                    return;
                }
            } catch {
                // parsing failed, fallback to API
            }
        }
        setIsLoading(true);

        doGetRequest(getSpinExchangeRatesRequest.request, {
            queryString: {
                bonusType,
            },
            successCallback: (data: SpinExchangeRate[]) => {
                setRates(data);
            },
        }).then(() => {
            setIsLoading(false);
        });

        return () => {
            getSpinExchangeRatesRequest.cancel?.('useOneSpinRates');
        };
    }, [bonusType, configJson, doGetRequest, getSpinExchangeRatesRequest]);

    return { rates, isLoading };
};

export default useOneSpinRates;
